import { useState } from 'react'
import { getUserStatisfactionByOrigin } from '../../../services/userSatisfaction'
import { getUserByLogin } from '../../../services/user'

export const UseSevenDaysModal = ()=>{
  const [showSevenDaysModal, setShowSevenDaysModal] = useState(false)

  const checkSevenDaysPassed = async () =>{
    const loggedUser = await getUserByLogin()
    const registerDate = new Date(loggedUser.data.createdAt)
    const passedDays = 7
    const now = Date.now()
    
    registerDate.setDate(registerDate.getDate() + passedDays)
    const isSevenDaysPassed = new Date(now).toISOString() >=  registerDate.toISOString();
   
    if (isSevenDaysPassed) {
      const AlwreadyAnswered = await checkSevenDaysPassedModalExists()
      handleSevenDaysModal(!AlwreadyAnswered) 
    } else {
      handleSevenDaysModal(false)
    }

  }

  const checkSevenDaysPassedModalExists = async () => {
    const response = await getUserStatisfactionByOrigin('sevenDays')
    if(response.data === null || Object.keys(response.data).length === 0 || response.data.deletedAt !== null || !!response.data.deletedAt){
      setShowSevenDaysModal(true)
      return false
    }else{
      setShowSevenDaysModal(false)
      return true
    }

  }

  const handleSevenDaysModal = (optionalShowModalParam) => {
    setShowSevenDaysModal(optionalShowModalParam ?? !showSevenDaysModal)
  }

  return{showSevenDaysModal, handleSevenDaysModal, checkSevenDaysPassedModalExists, checkSevenDaysPassed}
}